module.exports = __webpack_public_path__ + "static/media/background.4b5f33b5.jpg";